module.exports = __webpack_public_path__ + "static/media/WingBg04-sm.76f95b0c.jpg";